'use strict';

function indexOf(arr, el) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr && arr[i] === el) return i;
  }
  return -1;
}

module.exports = indexOf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/indexOf.js
// module id = 192
// module chunks = 1